export const RENDER_ZONE_ZINDEX = 100;

export const RENDER_PLACE_ZINDEX = 101;

export const RENDER_ZONEWALLPOINT_ZINDEX = 110;
